import CountUp from "react-countup";
import { Link } from "react-router-dom";
import { Col, List, ListInlineItem, Row } from "reactstrap";
import { UserFollowCounts, UserSocialLinks } from "../../../../../data/applications/Users";

const SocialMediaAndFollow = () => {
  return (
    <>
      <div className="social-media">
        <List type="inline" className="align-items-center">
          {/* Mapping through UserSocialLinks to display the social apps */}
          {UserSocialLinks.map(({ link, icon }, index) => (
            <ListInlineItem key={index}>
              <Link to={link} target="_blank">
                <i className={icon}></i>
              </Link>
            </ListInlineItem>
          ))}
        </List>
      </div>
      <div className="follow">
        <Row>
          {/* Mapping through UserFollowCounts to display the followers and following values */}
          {UserFollowCounts.map((item, index) => (
            <Col xs="6" className={item.class} key={index}>
              <CountUp end={item.count} className="follow-num" delay={1} />
              <span className="d-block">{item.text}</span>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
};

export default SocialMediaAndFollow;